/** Partner API namespace — only surface this SPA may call. */
export const partnerEndpoints = {
  login: "/v1/partner/auth/login/",
  resetPassword: "/v1/partner/auth/reset-password/",
  verifyPasswordReset: "/v1/partner/auth/verify-password-reset/",
  profile: "/v1/partner/profile/",
  applications: "/v1/partner/applications/",
  application: (uuid: string) => `/v1/partner/applications/${uuid}/`,
  documents: (uuid: string) => `/v1/partner/applications/${uuid}/documents/`,
  shareholders: (uuid: string) => `/v1/partner/applications/${uuid}/shareholders/`,
  shareholder: (uuid: string) => `/v1/partner/shareholders/${uuid}/`,
  documentTypes: "/v1/partner/document-types/",
  companyTypes: "/v1/partner/company-types/",
  kycReference: "/v1/partner/kyc/reference/",
  kycOverview: (uuid: string) => `/v1/partner/applications/${uuid}/kyc/`,
  businessKycCreate: (uuid: string) => `/v1/partner/applications/${uuid}/kyc/business/`,
  businessKycUpdate: (kycUuid: string) => `/v1/partner/kyc/business/${kycUuid}/update/`,
  personalKycCreate: (shareholderUuid: string) =>
    `/v1/partner/kyc/personal/create/${shareholderUuid}/`,
  personalKycUpdate: (kycUuid: string) => `/v1/partner/kyc/personal/${kycUuid}/update/`,
} as const;
